<template>
  <div
    :class="{
      [$style.footer]: true,
    }"
  >
    <div :class="$style.inner">
      <div class="row d-flex align-items-center justify-content-between">
        <div class="col-md-8">
          <p>&copy; {{ today | formatDate('YYYY') }} Truelife Software</p>
        </div>
        <div class="col-md-4">
          <div :class="$style.logo">
            <img src="resources/images/truelife-logo.png" alt="Truelife" />
            <div :class="$style.logoName">True Life</div>
            <div :class="$style.logoDescr">Admin Dashboard</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: mapState(['settings']),
  data() {
    return {
      today: new Date(),
    };
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
